<template>
  <div class="upload">

    <div class="title">
      <img src="../../assets/icon/INFOICON.png" alt="">
      <span>آپلود مدارک</span>
    </div>

    <div class="box">
      <div class="upload-form">
        <p class="upload-info">
          لطفا تصویر کارت ملی را در کنار چهره خودتان همراه با یک دست نوشته به صورت کاملا خوانا و واضح ، دقیقا مانند
          تصویر
          نمونه ، ارسال نمایید . دقت شود متن دست نوشته نبایستی تایپ شود. هم چنین توجه داشته باشید هنگام تهیه تصویر ، متن
          دست نوشته و اطلاعات کارت ملی به صورت برعکس و آینه ای ثبت نشود.
        </p>

        <p class="policy">
          این جانب ........... با شماره ملی ....... در تاریخ ........... مدارک خود را جهت احراز هویت در سایت ادا تتر
          ارسال
          و اعلام می کنم مدارک، حساب کاربری و اطلاعات کارت بانکی خود را در اختیار دیگری قرار نداده ام و متعهد می شوم از
          دریافت وجه و خرید ارز دیجیتال برای اشخاص دیگر تحت هر عنوانی )آگهی استخدام، کسب سود، کاریابی در منزل و ....(
          خودداری کنم. در غیر این صورت چنانچه وجهی از سوی دیگران برای خرید به حسابم واریز شد ، متوجه هستم که ممکن است
          وجه
          واریزی سرقتی باشد و مسوولیت حقوقی و قضایی آن اعم از مجاز ات قانونی و .جبران ضرر و زیان شاکی بر عهده بنده
          خواهد
          بود
        </p>

        <div class="upload-doc">
          <form class="insert-image" @submit.prevent="upload" @dragover.prevent @dragenter="hovered=!hovered" @dragleave="hovered=!hovered" @drop.stop.prevent="hovered=false;drop($event);" :style="{borderColor : hovered? 'blue' : ''}">
            <input @input="loadFile" type="file" class="file-input" @change="upload($event.target)" >
            <img id="image" src="../../assets/icon/upload.png" alt="">
            <img id="output-img"  alt="" src="">
            <h2 id="upload-image-sub">آپلود تصویر</h2>
          </form>
          <div class="example">
            <div class="list">
              <ul>
                <li>حجم عکس کمتر از 3 مگ باشد</li>
                <li>فرمت فایل PNG یا JPEG باشد</li>
                <li>تاریخ متن با تاریخ ارسال فایل یکی باشد</li>
                <li>حجم عکس کمتر از 3 مگ باشد</li>
                <li>فرمت فایل PNG یا JPEG باشد</li>
                <li>تاریخ متن با تاریخ ارسال فایل یکی باشد</li>
              </ul>
            </div>
            <div class="image">
              <div class="true-insert">
                <span>نمونه عکس قابل‌ قبول</span>
                <img src="../../assets/public/false.png" alt="">
              </div>

              <div class="false-insert">
                <span>نمونه عکس غیرقابل‌ قبول</span>
                <img src="../../assets/public/true.png" alt="">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "the-upload-doc",
  props:['data'],
   data() {
            return {
                path: '',
                loadedpicture: '',
                hovered: '',
            }
        },

  methods:{
    loadFile(event){
      var image = document.getElementById('output-img');
      // this.data.image=URL.createObjectURL(event.target.files[0]);
      image.src = URL.createObjectURL(event.target.files[0]);
      document.getElementById('upload-image-sub').style.display="none";
      document.getElementById('image').style.display="none";
      document.getElementById('output-img').style.display="block";
    },
      drop(e) {
                let dt = e.dataTransfer
                this.upload(dt)
            },
            upload(evt) {
                let file = evt.files[0]
                console.log(file)
                this.data.image = file
                let fileReader = new FileReader();
                fileReader.addEventListener("loadstart", (event) => {
                    this.loadedpicture = ((event.loaded / event.total) * 100).toFixed(0);
                })
                fileReader.addEventListener("progress", (event) => {
                    this.loadedpicture = ((event.loaded / event.total) * 100).toFixed(0);
                });
                fileReader.addEventListener('load', (event) => {
                    this.loadedpicture = ((event.loaded / event.total) * 100).toFixed(0);
                    this.path = event.target.result
                });
                fileReader.readAsDataURL(file)
            },
            hover() {
                this.hovered = true
            }
  }
}
</script>

<style lang="scss" scoped>
#output-img{
  width: 100%;
  max-height: 270px;
  display: none;
}

.upload {
  display: flex;
  flex-direction: column;

  .title {
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
    font-size: clamp(16px, 1vw, 22px);
    color: #FFFFFF;

    img {
      width: 74px;
      height: 74px;
      margin-right: -10px;
    }
  }

  .box {
    position: relative;
    padding: 40px;
    margin-bottom: 50px;

    &::before {
      background-image: url("../../assets/backgrounds/kyc-BOX.png");
      background-size: auto;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      content: "";
      opacity: 0.4;
      width: 100%;
      height: 100%;
      border-radius: 20px;
    }

    .upload-form {

      .upload-doc {
        display: flex;
        flex-direction: row;
        gap: 50px;
        width: 100%;
        flex-wrap: wrap;
        margin: 50px 0;


        .insert-image {
          width: 479px;
          border: 3px dashed rgba(215, 200, 200, 1);
          height: 274px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          color: rgba(251, 251, 253, 1);
          position: relative;

          .file-input{
            width: 100%;
            height: 100%;
            position: absolute;
            opacity: 0;
            z-index: 10;
          }
        }

        .example {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          flex-grow: 1;
          flex-wrap: wrap;
          gap: 50px;

          .list {
            color: #FBFBFD;
            font-size: 12px;
            text-align: right;

            ul {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              height: 95%;
              line-height: 2;

              li {
                position: relative;
                list-style: none;

                &:before {
                  content: '';
                  width: 5px;
                  height: 5px;
                  background-color: rgba(4, 178, 162, 1);
                  position: absolute;
                  display: inline-block;
                  border-radius: 50%;
                  right: -10px;
                  top: 10px;

                }
              }
            }
          }


          .image {
            display: flex;
            flex-direction: column;
            gap: 30px;

            .true-insert {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              color: #FBFBFD;
              font-size: 12px;
            }

            .false-insert {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              color: #FBFBFD;
              font-size: 12px;
            }

            img {
              width: 100px;
              height: 100px;
            }
          }

        }
      }

      .upload-info {
        color: #FBFBFD;
        text-align: right;
      }

      .policy {
        color: rgba(251, 251, 253, 0.7);
        text-align: right;
      }

      .public-input {
        width: 348px;
        height: 48px;
        position: relative;
        right: 20px;
      }

      .address-input {
        width: 715px;
        position: relative;
        right: 20px;
      }
    }
  }
}

@media (max-width: 992px){
  .box:before{
    background-size: cover !important;
  }
}
</style>